'use client';

import { useEffect, useState } from 'react';

import { GoogleTagManager } from '@next/third-parties/google';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';

import {
  CookieConsentGlobalStyle,
  ConsentContent,
  ConsentLink,
} from './cookie-consent.elements';

const COOKIE_CONSENT_NAME = 'izvrsnost_cookie_consent';
const COOKIE_ACCEPTED_VALUE = 'true';

const CookieConsentBanner = ({ gtmId }) => {
  const [hasAcceptedCookies, setHasAcceptedCookies] = useState(false);

  useEffect(() => {
    setHasAcceptedCookies(getCookieConsentValue(COOKIE_CONSENT_NAME) === COOKIE_ACCEPTED_VALUE);
  }, []);

  const handleAccept = () => {
    setHasAcceptedCookies(true);
  };

  const handleDecline = () => {
    setHasAcceptedCookies(false);
  };

  return (
    <>
      <CookieConsentGlobalStyle />
      <CookieConsent
        buttonText="Prihvaćam"
        declineButtonText="Odbijam"
        enableDeclineButton
        flipButtons
        onAccept={handleAccept}
        onDecline={handleDecline}
        cookieName={COOKIE_CONSENT_NAME}
        cookieValue={COOKIE_ACCEPTED_VALUE}
        declineCookieValue="false"
        location="bottom"
        setDeclineCookie
        sameSite="Lax"
        expires={180}
        disableStyles
        containerClasses="cookie-consent-banner"
        contentClasses="cookie-consent-banner__content"
        buttonWrapperClasses="cookie-consent-banner__actions"
        buttonClasses="cookie-consent-banner__button"
        declineButtonClasses="cookie-consent-banner__button cookie-consent-banner__button--decline"
        ariaAcceptLabel="Prihvati kolačiće"
        ariaDeclineLabel="Odbij kolačiće"
        extraCookieOptions={{ path: '/' }}
      >
        <ConsentContent>
          Koristimo kolačiće kako bismo omogućili ispravan rad stranice i, uz tvoju privolu,
          mjerili posjećenost radi unaprjeđenja korisničkog iskustva. Više informacija pronađi u{' '}
          <ConsentLink href="/zastita-osobnih-podataka">politici privatnosti</ConsentLink>.
        </ConsentContent>
      </CookieConsent>
      {gtmId && hasAcceptedCookies ? <GoogleTagManager gtmId={gtmId} /> : null}
    </>
  );
};

export { CookieConsentBanner };
